export default "__VITE_ASSET__c86575b2__"